<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="leftfloat">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style=" margin-bottom: 0;">
                  <div class="title_left">期刊动态</div>
                  <div class="title_more2"><a href="/">首页</a>>期刊动态</div>
                  <div class="clearfix"></div>
                </div>
                <listContent :params="{ColumnId:2}"></listContent>
                
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import DocumentsNewsBlockControl from '../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
  import listContent from '../components/listContent'
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first',
      }
    },
    components: {
      DocumentsNewsBlockControl,
      listContent
    },
    mounted(){
      document.title="期刊动态"
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
